export default "__VITE_ASSET__D1MgD2zy__"